import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, Icon, H2, Modal, NewButton, Text } from '../../../../../components';

const LeaveSpaceModalHeader = styled.div`
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}`;

const LeaveSpaceModalFooter = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 12px;
`;

const LeaveSpaceModalBody = styled.div`
  padding: 12px 24px 24px;
`;

const LeaveSpaceModal = ({ title, onLeaveSpace }) => (
  <Modal size='sm'>
    {(close) => (
      <>
        <LeaveSpaceModalHeader>
          <H2>Leave space</H2>
          <NewButton tertiary onClick={close}>
            <Icon name='close' size={24} />
          </NewButton>
        </LeaveSpaceModalHeader>
        <LeaveSpaceModalBody>
          <Text>
            Leaving <strong>{title}</strong> will remove access to this view.
            <br />A new invitation will be needed to rejoin.
          </Text>
        </LeaveSpaceModalBody>
        <LeaveSpaceModalFooter>
          <Button onClick={close} tertiary>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onLeaveSpace();
              close();
            }}
            secondary
          >
            Yes, leave
          </Button>
        </LeaveSpaceModalFooter>
      </>
    )}
  </Modal>
);

LeaveSpaceModal.propTypes = {
  title: PropTypes.string.isRequired,
  onLeaveSpace: PropTypes.func.isRequired
};

export { LeaveSpaceModal };
